import InfoOutlined from '@mui/icons-material/InfoOutlined';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Drawer } from '@openx/components-core/lib/Drawer/Drawer';
import { DrawerActionBar } from '@openx/components-core/lib/Drawer/DrawerActionBar';
import { DrawerHeader } from '@openx/components-core/lib/Drawer/DrawerHeader';
import { useTranslation } from 'react-i18next';
import { ExportRulesDrawerParagraph } from './ExportRulesDrawerParagraph';
import { getParagraphs } from './utils';

type ExportRulesDrawerProps = {
  onClose: () => void;
  open: boolean;
};

export const ExportRulesDrawer = ({ onClose, open }: ExportRulesDrawerProps) => {
  const { t } = useTranslation();

  const paragraphs = getParagraphs(t);

  return (
    <Drawer onClose={onClose} open={open}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <DrawerHeader onClose={onClose}>{t('Export to CSV — Eligibility Rules')}</DrawerHeader>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            gap: 1,
            paddingX: 2,
            paddingTop: 1.5,
            paddingBottom: 3,
            backgroundColor: 'info.light',
          }}
        >
          <InfoOutlined data-test="info-outline" sx={{ fontSize: '20px', color: 'info.main', marginTop: '3px' }} />

          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 3,
            }}
          >
            <Typography variant="body1">
              {t(
                'You can export your segments to CSV only when your selection meets one of the allowed combinations below.'
              )}
            </Typography>

            {paragraphs.map(({ title, description }) => (
              <ExportRulesDrawerParagraph key={title} title={title} description={description} />
            ))}
          </Box>
        </Box>
      </Box>
      <DrawerActionBar actions={[{ label: t('Close'), onClick: onClose, variant: 'text' }]} hideDivider stickyBottom />
    </Drawer>
  );
};
